import Head from 'next/head';

interface SchemaMarkupProps {
  jsonLd?: string;
  id: string; // unique id per schema block
}

export default function SchemaMarkup({ jsonLd, id }: SchemaMarkupProps) {
  if (!jsonLd) return null;

  return (
    <Head>
      <script
        key={`jsonld-schema-${id}`} // unique key per script
        dangerouslySetInnerHTML={{ __html: jsonLd }}
        type='application/ld+json'
      />
    </Head>
  );
}
